module.exports = __webpack_public_path__ + "static/media/oneonone.db0cc061.png";